"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.planForRung = exports.DOSE_APPROVAL_VALID_DAYS = exports.SELF_SERVE_DOSE_STEPS = exports.doseSteps = exports.doseLadder = void 0;
/**
 * A program's dose ladder: its distinct doses, lowest rung first.
 *
 * Program dosage plans already list doses in titration order (starter plan,
 * then continuation plans from the lowest dose up), and a starter and a
 * continuation plan at the same dose are one rung. A rung is identified by
 * its doseLabel ("5mg weekly"), which is what the patient takes.
 */
function doseLadder(plans = []) {
    const rungs = [];
    for (const plan of plans) {
        const label = plan.doseLabel.trim();
        if (label && !rungs.includes(label))
            rungs.push(label);
    }
    return rungs;
}
exports.doseLadder = doseLadder;
/** How far apart two doses sit on the ladder, either direction; null when either is not on it. */
function doseSteps(plans, fromDoseLabel, toDoseLabel) {
    const ladder = doseLadder(plans);
    const from = ladder.indexOf(fromDoseLabel.trim());
    const to = ladder.indexOf(toDoseLabel.trim());
    return from < 0 || to < 0 ? null : Math.abs(to - from);
}
exports.doseSteps = doseSteps;
/** Moves of up to this many rungs the patient orders directly; further ones go to the clinic first. */
exports.SELF_SERVE_DOSE_STEPS = 1;
/** How long an approved dose change can be ordered before it lapses. */
exports.DOSE_APPROVAL_VALID_DAYS = 60;
/**
 * The plan an existing patient orders at a rung: the continuation plan at
 * that dose, else the starter plan (a program whose only plan is a starter).
 */
function planForRung(plans, doseLabel) {
    const atRung = plans.filter(p => p.doseLabel.trim() === doseLabel.trim());
    const preferred = 'continuation';
    return atRung.find(p => p.path === preferred) || atRung[0];
}
exports.planForRung = planForRung;
//# sourceMappingURL=doseLadder.js.map